<template>
    <div class="planAlokasiChart" ref="planAlokasiChart" style="width: 100%; height: 400px;"></div>
</template>

<script>
    /* Imports */
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";

    export default {
        name: 'ColumnBarChart',
        data () {
            return {
                chart : null,
            }
        },
        props : ['data'],
        mounted() {
            this.createChart();
            this.getData();
        },
        beforeDestroy() {
            if (this.chart) this.chart.dispose();
        },
        watch : {
            'data' : {
                deep : true,
                handler : 'getData'
            }
        },
        methods : {
            getData () {
                const totalColor = [];
                let letters = '0123456789ABCDEF';
                for (let i = 0; i < this.data.length; i++) {
                    let color = '#';
                    for (let j = 0; j < 6; j++) {
                    color += letters[Math.floor(Math.random() * 16)];
                    }
                    totalColor.push(color);
                }
                let data = this.data && this.data.length > 0 ? this.data.map((x, i)=>{return {
                    plant_name : `Plant ${x.plant_name}`,
                    quantity : x.quantity,
                    color : totalColor[i%totalColor.length]
                }}) : [{
                    plant_name: 'No Data',
                    quantity: 1,
                    color: '#83A2FF'
                }];

                this.chart.data = data;
            },
            createChart () {
                // Apply the animated theme for some basic chart animations
                am4core.useTheme(am4themes_animated);

                // Create the chart instance
                this.chart = am4core.create(this.$refs.planAlokasiChart, am4charts.XYChart);

                // Add data to the chart (you can replace this with your own data)
                // this.chart.data = [
                //     { plant_name: 'Plant 1100', quantity: 51, color: '#83A2FF' },
                //     { plant_name: 'Plant 1200', quantity: 35, color: '#FF83A2' },
                //     { plant_name: 'Plant 1300', quantity: 39, color: '#83FFE0' },
                //     { plant_name: 'Plant 1350', quantity: 75, color: '#FFE083' },
                //     { plant_name: 'Plant 1700', quantity: 9, color: '#C8FFA3' },
                //     { plant_name: 'Plant 1800', quantity: 29, color: '#DABAFF' },
                // ];

                // Create category axis
                const categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
                categoryAxis.dataFields.category = 'plant_name';
                categoryAxis.renderer.grid.template.disabled = true;
                // categoryAxis.title.text = 'Plants';

                // Create value axis
                const valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
                valueAxis.title.text = 'Unit';

                // Set the visible maximum limit on the y-axis to 100
                valueAxis.min = 0;

                // Create series
                const series = this.chart.series.push(new am4charts.ColumnSeries());
                series.dataFields.valueY = 'quantity';
                series.dataFields.categoryX = 'plant_name';
                series.name = 'Value Series';
                series.columns.template.tooltipText = '{categoryX}: [bold]{valueY}[/]';

                // Set the color of each bar based on the "color" property in the data
                series.columns.template.propertyFields.fill = 'color';

                // Remove the border color
                series.columns.template.strokeOpacity = 0;

                // Make the edges of the bars round
                series.columns.template.column.cornerRadiusTopLeft = 2;
                series.columns.template.column.cornerRadiusTopRight = 2;

                // Set the width of the columns
                series.columns.template.width = am4core.percent(25); // Change this value to make columns wider or narrower

                series.columns.template.tooltipText = '{categoryX}: [bold]{valueY}[/]';

                this.chart.cursor = new am4charts.XYCursor();
            }
        }
    };
</script>

<style>
    /* Add any custom styles here if needed */
</style>
